import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Spin } from 'antd';
import Login from '../Component/Login';
import Home from '../Component/Dashboard/Home';
import ProfileForm from '../Component/ProfileForm';
import NoPageFound from '../Component/NoPageFound';
import ManageUser from '../Component/UserManagement/ManageUser';
import Addclinic from '../Component/clinicSetting/Addclinic';
import ClinicianProfile from '../Component/clinicianProfile/ClinicianProfile';
import ProtectedRoute from './ProtectedRoute';
import GPPricingMatrix from '../Component/GPPricingMatrix/GPPricingMatrix';
import Gpproductadmin from '../Component/Gpproductadmin/Gpproductadmin';
import ProductCategory from '../Component/ProductCategory/ProductCategory';
import CorporateProduct from '../Component/CorporateProduct/CorporateProduct'
import CorporateCustomer from '../Component/CorporateCustomer/CorporateCustomer'
import Partner from '../Component/Partner/Partner'
import axios from 'axios';
import AppContext from '../Component/context/appContext';
import CancelRule from '../Component/CancelRule/CancelRule';
import Test from '../test';
import ReschedulingRules from '../Component/ReschedulingRules/ReschedulingRules';
import ClinicCalendarPage from '../Component/Dashboard/ClinicCalendarPage';
import NewProductCategory from '../Component/ProductCategoryNew/NewProductCategory';
import PaymentSettings from '../Component/PaymentSettings';
import SignalDetailsData from '../Component/Dashboard/SignalDetailsData';
import PendingRefunds from '../Component/Dashboard/PendingRefunds';
import { Config } from '../Component/Common/Config';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import GenericEmailCopy from '../Component/GenericEmailCopy/GenericEmailCopy';
import Other from '../Component/Other/Other';
import GenericSMSCopy from '../Component/GenericSMSCopy/GenericSMSCopy';
import Alerts from '../Component/Alerts/Alerts';
import ResetPassword from '../Component/ResetPassword';
import Test2Pyment from '../Test2Pyment';
import AuditLogs from '../Component/audit-logs/AuditLogs';
import Index from '../Component/adminEmail/pages/Index';
import BankHoliday from '../Component/BankHoliday';
import AbandonedJourneyDashboard from '../Component/AbandonedJourney/AbandonedJourneyDashboard';
import Patients from '../Component/Patients/Patients';

const MainRouter = (props) => {
  const [metaData, setmetaData] = useState(null)
  const [role, setRole] = useState(null);
  const [publicKey, setPublicKey] = useState(null);
  const [contextLoading, setContextLoading] = useState(true);
  useEffect(() => {
    const fetchPublicKey = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL_LOGIN}/api/v1/payment-keys`, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        // Assuming you want the first key in the array
        const key = response?.data?.data?.[0]?.public_key;
        // console.log('Fetched public key:', key);
        if (key) setPublicKey(key);
      } catch (error) {
        console.log('Error fetching public key:', error);
      }
    };
    fetchPublicKey();
  }, []);
 useEffect(() => {
  const fetchAll = async () => {
    await getAllMetaData();
    await getAllProductData(1)
    setContextLoading(false);
  };
  fetchAll();
}, []);
   const getAllProductData = async (CurrentPage, searchValue = null) => {
    if (!localStorage.getItem('token')) {
      return
    }
    try {
      // IOO-300: fetch all categories in one shot so sidebar never shows < full list
      let url = `${Config.url}product-category/page/1?per_page=-1`
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const rawList = response?.data?.data?.data;
      if (rawList && rawList.length) {
        let category = {}
        rawList.forEach(cat => {
          if (cat?.product_category_id) {
            category[`category${cat.product_category_id}`] = cat
          }
        })
        if (category && Object.keys(category).length) {
          localStorage.setItem('showCategory', JSON.stringify(category))
        }
      }
    } catch (error) {
      console.log('error in product-category ::::', error)
    }
  }
  const getAllMetaData = async () => {
  if (!localStorage.getItem('token')) return;
  try {
    const response = await axios.get(`${Config.urlLogin}/api/v1/meta-data`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      params: { category: "clinician_type" }
    });
    if (response?.data?.data && response?.data?.data.data) {
      setmetaData(response?.data?.data.data);
    }
  } catch (error) {
    console.log('error in get clinic data ::::', error)
  }
};
  // console.log('publicKey ::::', publicKey)
const stripePromise = publicKey
  ? loadStripe(publicKey)
  : null;

  // let localFlag = window.location.origin.includes('localhost')
  
  return contextLoading ? <Spin className="custom-spinner" style={{marginTop: '50px'}} /> : (
  <AppContext.Provider value={{ metaData, role, setRole }}>
    <BrowserRouter>
      <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/user-management" element={<ProtectedRoute><ManageUser /></ProtectedRoute>} />
          <Route path="/user-management/patients" element={<ProtectedRoute><Patients /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfileForm /></ProtectedRoute>} />
          <Route path="/clinic-settings" element={<ProtectedRoute><Addclinic /></ProtectedRoute>} />
          <Route path="/clinician-profile" element={<ProtectedRoute><ClinicianProfile /></ProtectedRoute>} />
          <Route path="/gp-pricing" element={<ProtectedRoute><GPPricingMatrix /></ProtectedRoute>} />
          <Route path="/gp-product-admin" element={<ProtectedRoute><Gpproductadmin /></ProtectedRoute>} />
          <Route path="/product-category" element={<ProtectedRoute><ProductCategory /></ProtectedRoute>} />
          <Route path="/corporate-product" element={<ProtectedRoute><CorporateProduct /></ProtectedRoute>} />
          <Route path="/corporate-customer" element={<ProtectedRoute><CorporateCustomer /></ProtectedRoute>} />
          <Route path="/partner" element={<ProtectedRoute><Partner /></ProtectedRoute>} />
          <Route path="/audit-logs" element={<ProtectedRoute><AuditLogs /></ProtectedRoute>} />
          <Route path="/email-admin" element={<ProtectedRoute><Index /></ProtectedRoute>} />
          <Route path="/cancellation-rules" element={<ProtectedRoute><CancelRule /></ProtectedRoute>} />
          <Route path="/rescheduling-rules" element={<ProtectedRoute><ReschedulingRules /></ProtectedRoute>} />
          <Route path="/clinic-calendar-page" element={<ProtectedRoute><Elements stripe={stripePromise}><ClinicCalendarPage /></Elements></ProtectedRoute>} />
          <Route path="/product-categories" element={<ProtectedRoute><NewProductCategory /></ProtectedRoute>} />
          <Route path="/payment-settings" element={<ProtectedRoute><PaymentSettings /></ProtectedRoute>} />
          <Route path="/signal-details" element={<ProtectedRoute><SignalDetailsData /></ProtectedRoute>} />
          <Route path="/pending-refunds" element={<ProtectedRoute><PendingRefunds /></ProtectedRoute>} />
          <Route path="/generic-email-copy" element={<ProtectedRoute><GenericEmailCopy /></ProtectedRoute>} />
          <Route path="/generic-sms-copy" element={<ProtectedRoute><GenericSMSCopy /></ProtectedRoute>} />
          <Route path="/alert" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
          <Route path="/others" element={<ProtectedRoute><Other /></ProtectedRoute>} />
          <Route path="/bank-holidays" element={<ProtectedRoute><BankHoliday /></ProtectedRoute>} />
          {/* <Route path="/abandoned-journey" element={<ProtectedRoute><AbandonedJourneyDashboard /></ProtectedRoute>} /> */}
          <Route path="/test" element={<ProtectedRoute><Elements stripe={stripePromise}><Test2Pyment /></Elements></ProtectedRoute>} />
          
          <Route path="*" element={<NoPageFound />} />
        </Routes>
    </BrowserRouter>
  </AppContext.Provider>
);
};

export default MainRouter
